// Holds the password the user just logged in with, in memory only, so the
// forced change-password screen doesn't make them retype a temporary password.
// Never persisted (not in router state, which lives in history.state).
let pendingPassword = null;

export const setPendingPassword = (password) => {
  pendingPassword = password;
};

export const peekPendingPassword = () => pendingPassword;

export const clearPendingPassword = () => {
  pendingPassword = null;
};
